import { render } from "./StreamlinedButton.vue?vue&type=template&id=0b5e251b&scoped=true"
import script from "./StreamlinedButton.vue?vue&type=script&lang=ts"
export * from "./StreamlinedButton.vue?vue&type=script&lang=ts"

import "./StreamlinedButton.vue?vue&type=style&index=0&id=0b5e251b&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0b5e251b"

export default script